<template>
    <div>
        <b-tabs>
            <b-tab v-if="hasRule('Signature')" title="Assinatura Digital">
                <ScrollBar :minHeight="500" :maxHeight="500">
                    <SignerListForMessaging />
                </ScrollBar>
            </b-tab>
            <b-tab v-if="userLogged.user.type == 1" title="Autorização">
                <ScrollBar :minHeight="500" :maxHeight="500">
                    <AuthorizationTable />
                </ScrollBar>
            </b-tab>
            <b-tab title="E-mails Enviados">
                <ScrollBar :minHeight="500" :maxHeight="500">
                    <Emails />
                </ScrollBar>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import AuthorizationTable from '../adm/authorization/AuthorizationTable.vue'

import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import SignerListForMessaging from '../signature/signer/SignerListForMessaging.vue'
import Emails from './Emails.vue'

import { mapGetters, mapState } from "vuex";

export default {
    name: "Messaging",
    components: { ScrollBar, Emails, SignerListForMessaging, AuthorizationTable },
    computed: {
        ...mapGetters("user", ["hasRule"]),
        ...mapState("user", ["userLogged"]),
    }
}

</script>